import { ResourceType } from 'gen/api';
import { errorHandler } from '../../utils/errorHandler';
import axiosInterceptor from '../interceptor/axiosClient';
interface SharedByUserInfo {
  userId: string;
  username: string;
}

interface ResourceSharedNotification {
  sharedByUserInfo: SharedByUserInfo;
  resourceType: ResourceType;
  resourceId: string;
  resourceTitle: string;
}

interface NotificationContent {
  type: string;
  resourceSharedNotification: ResourceSharedNotification;
}

export interface Notification {
  notificationId: string;
  createdAt: string;
  notificationContent: NotificationContent;
}

export type NotificationsResponse = Notification[];
export const fetchNotifications = async (
  pageNumber: number = 0,
  pageSize: number = 10,
): Promise<NotificationsResponse> => {
  try {
    const { data } = await axiosInterceptor.get<NotificationsResponse>('/notification', {
      params: {
        pageSize,
        pageNumber,
      },
    });

    return data;
  } catch (error: any) {
    errorHandler(error);
    throw error;
  }
};
